var _path, _g, _ellipse, _path2, _path3, _path4, _path5, _path6, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatnotfound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 164,
    viewBox: "0 0 188 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9125 52.0978V116.942C39.9125 124.133 43.3367 126.359 45.0488 126.573H136.217C142.556 126.573 144.563 123.269 144.563 121.437V68.1484C144.563 62.4986 140.283 61.5141 138.143 61.7281H86.1385C82.2863 61.7281 78.4342 60.4442 78.4342 52.0978C78.4342 45.4208 72.4419 44.6075 69.4458 45.0355H48.2589C40.5546 45.0355 39.4845 49.7437 39.9125 52.0978Z",
    fill: "#1B75BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1647_74458)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.0693,
    width: 65.4867,
    height: 80.8953,
    fill: "#E8F1F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 5.13574,
    width: 57.7824,
    height: 17.9767,
    fill: "#B8D4EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0464,
    y: 26.9648,
    width: 43.6578,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 32.1016,
    width: 57.7824,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 37.2373,
    width: 57.7824,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 42.374,
    width: 57.7824,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 47.5098,
    width: 57.7824,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 52.6465,
    width: 57.7824,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 57.7822,
    width: 39.8056,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9214,
    y: 62.9189,
    width: 39.8056,
    height: 1.28405,
    fill: "#BDBEC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.295,
    y: 57.7822,
    width: 15.4086,
    height: 10.2724,
    fill: "#B8D4EA"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 91.5,
    cy: 152,
    rx: 91.5,
    ry: 12,
    fill: "#B8D4EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7763 52.0978V116.942C34.7763 124.133 38.2005 126.359 39.9126 126.573H131.08C139.298 126.573 139.427 123.911 139.427 121.437V68.1484C139.427 62.4986 135.146 61.5141 133.006 61.7281H81.0023C77.1501 61.7281 73.298 60.4442 73.298 52.0978C73.298 45.4208 67.3057 44.6075 64.3096 45.0355H43.1226C35.4183 45.0355 34.3483 49.7437 34.7763 52.0978Z",
    fill: "#DDEAF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.994 105.236L157.578 110.067L129.501 84.4053L133.918 79.5735L161.994 105.236Z",
    fill: "#2A2E34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.871 105.856C168.771 106.566 168.915 107.875 168.192 108.763L162.671 115.544C161.898 116.492 160.473 116.559 159.615 115.686L139.946 95.6634C139.181 94.8838 139.16 93.6409 139.9 92.8364L143.432 88.994C144.159 88.2039 145.371 88.107 146.214 88.7717L167.871 105.856Z",
    fill: "#1B75BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.298 57.6596C137.269 41.5471 121.675 30.9532 105.563 33.9825C89.4504 37.0118 78.8564 52.6053 81.8858 68.7178C84.9151 84.8303 100.509 95.4242 116.621 92.3949C132.754 89.3102 143.403 73.737 140.298 57.6596ZM136.997 58.2744C139.707 72.5121 130.32 86.349 116.026 89.0384C101.789 91.748 87.9519 82.3609 85.2625 68.0678C82.5528 53.8301 91.94 39.9933 106.233 37.3038C120.526 34.6144 134.287 44.0367 136.997 58.2744Z",
    fill: "#1B75BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.585 92.8443C107.826 93.954 112.355 94.1018 116.821 93.2217C124.849 91.6969 131.789 87.1373 136.404 80.3473C141.019 73.5573 142.724 65.4529 141.2 57.4243C139.675 49.3958 135.115 42.456 128.325 37.8408C121.535 33.2255 113.431 31.5205 105.402 33.0453C88.8008 36.2099 77.8586 52.2412 81.0435 68.7873C82.5683 76.8158 87.1278 83.7556 93.9179 88.3708C96.8974 90.5267 100.195 91.9827 103.585 92.8443ZM118.232 35.2209C121.455 36.0217 124.512 37.4522 127.386 39.3811C133.773 43.7237 138.046 50.2449 139.491 57.8047C140.936 65.3646 139.337 73.0056 134.995 79.3929C130.652 85.7803 124.131 90.0533 116.571 91.4982C112.312 92.3282 108.065 92.0952 104.102 91.0866C93.6004 88.3804 85.0376 79.8527 82.8426 68.5028C79.8932 52.8589 90.174 37.7789 105.818 34.8295C109.946 34.0144 114.213 34.1921 118.232 35.2209ZM104.406 89.5654C108.204 90.5133 112.229 90.6654 116.15 89.9003C130.857 87.1108 140.592 72.8361 137.803 58.1297C136.458 50.9831 132.436 44.805 126.396 40.7149C120.356 36.6247 113.123 35.1125 106.032 36.4774C98.8855 37.8221 92.7073 41.8437 88.6172 47.8838C84.527 53.9239 83.0148 61.1569 84.3797 68.2481C85.7245 75.3946 89.7461 81.5728 95.7861 85.6629C98.4589 87.4555 101.369 88.7699 104.406 89.5654ZM136.114 58.4547C138.744 72.2237 129.67 85.5471 115.846 88.1566C109.168 89.4214 102.398 88.0156 96.781 84.1428C91.1436 80.3253 87.3532 74.5456 86.0884 67.8677C84.8236 61.1898 86.2293 54.4202 90.1022 48.803C93.9196 43.1656 99.6994 39.3752 106.377 38.1104C113.055 36.8456 119.825 38.2513 125.442 42.1242C131.059 45.9971 134.849 51.7768 136.114 58.4547Z",
    fill: "#1B75BC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.965 37.9126C123.882 37.2834 135.757 48.0884 136.366 62.061C136.995 75.9782 126.19 87.853 112.217 88.462C98.2446 89.071 86.4253 78.2862 85.8162 64.3136C85.2072 50.341 96.0474 38.5419 109.965 37.9126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.13 38.5846C127.802 41.1651 135.875 50.5184 136.387 62.0069C136.525 64.3802 136.254 66.6673 135.742 68.9288L117.13 38.5846Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6678 45.9093L118.181 87.4391C116.281 88.0006 114.275 88.3352 112.239 88.4078C109.886 88.4899 107.579 88.2749 105.373 87.7828L86.5092 57.0956C87.6189 52.8549 89.7055 49.0338 92.6678 45.9093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.498 38.1434L131.835 77.7367C130.901 79.0906 129.821 80.3285 128.575 81.5056L102.669 39.3303C104.177 38.8136 105.83 38.413 107.498 38.1434Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1597 43.557L121.422 86.3023C121.12 86.4429 120.893 86.5484 120.59 86.689L94.4886 44.1909C94.7006 43.9544 94.968 43.7381 95.1597 43.557Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9332 65.5511L97.5943 84.503C96.9349 84.0738 96.3309 83.6647 95.7471 83.2003L86.2423 67.7987C86.1325 67.0679 86.0227 66.3372 85.9332 65.5511Z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1647_74458",
    x: 77.0693,
    y: 0,
    width: 68.0549,
    height: 87.3158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.28405,
    dy: 5.13621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.642026
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1647_74458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1647_74458",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatnotfound);
export default __webpack_public_path__ + "static/media/Chat not found.d1e930932c6791d8d79bdd50abebda4b.svg";
export { ForwardRef as ReactComponent };